__turbopack_context__.v({
  "beamLayer01": "style-module-scss-module__5D9Vxq__beamLayer01",
  "beamLayer02": "style-module-scss-module__5D9Vxq__beamLayer02",
  "beamLayer03": "style-module-scss-module__5D9Vxq__beamLayer03",
  "beamLayer04": "style-module-scss-module__5D9Vxq__beamLayer04",
  "beamLayer05": "style-module-scss-module__5D9Vxq__beamLayer05",
  "beamLayer06": "style-module-scss-module__5D9Vxq__beamLayer06",
  "desktopLayer": "style-module-scss-module__5D9Vxq__desktopLayer",
  "desktopRoot": "style-module-scss-module__5D9Vxq__desktopRoot",
  "mobileLabel": "style-module-scss-module__5D9Vxq__mobileLabel",
  "mobileLabel01": "style-module-scss-module__5D9Vxq__mobileLabel01",
  "mobileLabel02": "style-module-scss-module__5D9Vxq__mobileLabel02",
  "mobileLabel03": "style-module-scss-module__5D9Vxq__mobileLabel03",
  "mobileLabel04": "style-module-scss-module__5D9Vxq__mobileLabel04",
  "mobileLabel05": "style-module-scss-module__5D9Vxq__mobileLabel05",
  "mobileLabel06": "style-module-scss-module__5D9Vxq__mobileLabel06",
  "mobileLayer": "style-module-scss-module__5D9Vxq__mobileLayer",
  "mobileRoot": "style-module-scss-module__5D9Vxq__mobileRoot",
});
